import React from 'react';
import { compose } from 'redux';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import {
  withMobileContext,
  WithMobileContextProps,
} from '@wix/da-shared-react/pkg/Context/MobileContext';
import { ShopItemType } from '../../../../../types/shop';
import ShopGrid from '../ShopGrid';
import ShopCommissionsControls from './ShopCommissionsControls';
import s from '../ShopSection.scss';

export interface Props {
  className?: string;
  isOwner: boolean;
  isOpenForCommissions: boolean;
}

const enhance = compose(withMobileContext, withSectionFetchSpinner);
export class ShopCommissions extends React.Component<
  Props & WithMobileContextProps
> {
  render() {
    const { className, isOpenForCommissions, isOwner, isMobile } = this.props;

    return (
      <div className={s['section-with-no-header']}>
        <ShopCommissionsControls />
        {(isOpenForCommissions || (isOwner && !isMobile)) && (
          <ShopGrid
            className={className}
            itemType={ShopItemType.COMMISSIONS}
            emptyState={false}
          />
        )}
      </div>
    );
  }
}

export default enhance(ShopCommissions) as React.ComponentType<Props>;
